import React from "react"
import game from "red-card.png"

const RedCard = props => <img src={game} className="game" {...props} />

export default RedCard
